/* @flow */
import _ from "lodash";
import { ShoppingList } from "../datatypes/ShoppingList";

export function enhanceListWithCalculatedUniqAmount(list: ShoppingList) {
    const uniqAmount = _.uniqBy(list.items, (item) => item.bettyBundleId).length;
    return _.assign({}, list, { uniqAmount });
}

export function getAmountsToShowDynamicListsPreview(showCIP: boolean, showRecentlyBought: boolean) {
    return _.reduce(
        [showCIP, showRecentlyBought],
        (sum: number, value: boolean) => {
            return value ? sum + 1 : sum;
        },
        0
    );
}

export const TYPE_CIP = "cip";
export const TYPE_RECENTLY_BOUGHT = "recentlyBought";
export type ListType = typeof TYPE_CIP | typeof TYPE_RECENTLY_BOUGHT;
export const MAX_NUMBER_OF_ARTICLES_TO_SHOW_PER_DYNAMIC_LIST = 10;
export const RECENTLY_BOUGHT_LISTID = "recentlybought";
export const CIP_LISTID = "cip";
export const DYNAMIC_LIST_IDS = [RECENTLY_BOUGHT_LISTID, CIP_LISTID];
